<app-menu [moduloEnum]="moduloEnum" [funcionalidadeEnum]="funcionalidadeEnum"></app-menu>

<div class="container">
    <h1 class="title-default">Home</h1>
    <p class="welcome-message">
      Olá, <span class="display-name">{{ nomeUsuario }}</span>! Bem vindo ao administrador da ATS.
    </p>
    @if (listaModulos && listaModulos.length > 0) {
      <div class="container-geral">
        <p class="modules-description">
          Tudo pronto para começar! Navegue pelos seus módulos abaixo e acesse as ferramentas para impulsionar sua gestão.
        </p>
          <div class="container-atalhos">
              @for (modulo of listaModulos; track modulo.idModulo) {
                <a mat-ripple class="atalho-card" routerLink="{{modulo.uri}}">
                    <div class="icon-container">
                    <span class="material-symbols-outlined">{{modulo.googleIconClass}}</span>
                    </div>
                    <label>{{modulo.nome}}</label>
                </a>
              }
          </div>
      </div>
    }
</div>